var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"flex",staticStyle:{"justify-content":"space-between"}},[_c('Title',{attrs:{"title":"筛选条件"}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }